import { useTranslate } from "@tolgee/react";
import React, { useState } from "react";
import Calendar from "./Calendar";
import {ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import InstagramFeedPreview from "./IGFeedPreview";
import { VIEW_STATUS } from "../../../config/constants";
import { useSelector } from "react-redux";
import { lomavisCreatorRootState } from "../../../../../pages/lomavisCreator";
import HeatmapChart from "../../../../analytics/heatmapWithSource";
import PlatformHeatmapList from "../../../../analytics/heatmapList";

interface Props {
  locationslug: string;
}

const RightScheduling: React.FC<Props> = ({ locationslug }) => {
  const { t } = useTranslate();
  const [viewDisplayed, setViewDisplayed] = useState<String>(
    VIEW_STATUS.CALENDAR
  );
  const [filterArray, setFilterArray] = useState([
    "Draft",
    "Approval",
    "Planned",
    "Published",
  ]);
  const [loadingData, setLoadingData] = useState(false);
  const isMultiPost = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.is_multipost
  );
  const listedStatus = [
    { name: t("draft"), key: "Draft", color: "text-warning", bg: "bg-warning" },
    {
      name: t("approval"),
      key: "Approval",
      color: "text-info",
      bg: "bg-info",
    },
    {
      name: t("planned"),
      key: "Planned",
      color: "text-primary",
      bg: "bg-primary",
    },
    {
      name: t("published"),
      key: "Published",
      color: "text-success",
      bg: "bg-success",
    },
  ];

  const handleToggleChange = (value) => {
    setViewDisplayed(value);
  };

  return (
    <div className="w-100 d-flex flex-column gap-5 justify-content-between position-relative flex-fill h-100">
      <div className="w-100 d-flex flex-column gap-5 h-100 ">
        <div
          style={{ height: "50px" }}
          className="d-flex justify-content-end align-items-center flex-wrap my-4 flex-fill "
        >
          {loadingData && (
            <div className="d-flex justify-content-center align-item-center mx-4">
              <div
                style={{ width: "1.5rem", height: "1.5rem" }}
                className="spinner-border "
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          <ToggleButtonGroup
            type="radio"
            name="options"
            value={viewDisplayed}
            onChange={(value) => setViewDisplayed(value)}
          >
            <ToggleButton
              variant="secondary"
              value={VIEW_STATUS.CALENDAR} // Set the value for this button
              size="sm"
              id="tbg-radio-3"
              key="tbg-radio-3"
              className="d-flex justify-content-center align-items-center"
              onClick={() => setViewDisplayed(VIEW_STATUS.CALENDAR)}
            >
              <i className="fa-duotone fa-calendar-days"></i>
              {t("lomavisCreator.planningSlide.calendar")}
            </ToggleButton>
            <ToggleButton
              variant="secondary"
              value={VIEW_STATUS.BEST_TIME_TO_POST} // Set the value for this button
              size="sm"
              id="tbg-radio-5"
              key="tbg-radio-5"
              className="d-flex justify-content-center align-items-center"
              onClick={() => setViewDisplayed(VIEW_STATUS.BEST_TIME_TO_POST)}
            >
              <i className="fa-duotone fa-light fa-timer"></i>
              {t("lomavisCreator.planningSlide.best time to post")}
            </ToggleButton>

            {!isMultiPost && (
              <ToggleButton
                variant="secondary"
                value={VIEW_STATUS.IG_FEED_PREVIEW} // Set the value for this button
                size="sm"
                id="tbg-radio-4"
                key="tbg-radio-4"
                className="d-flex justify-content-center align-items-center"
                onClick={() => setViewDisplayed(VIEW_STATUS.IG_FEED_PREVIEW)}
              >
                <i className="fa-brands fa-instagram text-danger"></i>
                {t("lomavisCreator.planningSlide.iInstagram.feed_preview")}
              </ToggleButton>
            )}
          </ToggleButtonGroup>
        </div>
        <div
          style={{ overflowY: "scroll" }}
          className="d-flex flex-column gap-3 justify-content-center flex-fill h-100 "
        >
          {(viewDisplayed === VIEW_STATUS.CALENDAR || viewDisplayed === VIEW_STATUS.IG_FEED_PREVIEW) && <div className="d-flex gap-4 justify-content-center align-items-center">
            {listedStatus.map((item, index) => (
              <div
                key={item.key + index}
                className="d-flex justify-content-center align-items-center gap-1 text-dark"
                style={{
                  cursor: "pointer",
                }}
                onClick={
                  filterArray.includes(item.key)
                    ? () => {
                        setFilterArray(
                          filterArray.filter((i) => i !== item.key)
                        );
                      }
                    : () => {
                        setFilterArray((prevState) => [...prevState, item.key]);
                      }
                }
              >
                <div
                  style={{
                    width: "14px",
                    height: "14px",
                    cursor: "pointer",
                  }}
                >
                  {filterArray.includes(item.key) ? (
                    <div
                      style={{
                        width: "14px",
                        height: "14px",
                      }}
                      className={`rounded-circle ${item.bg}`}
                    ></div>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <i className={`far fa-ban ${item.color}`}></i>
                    </div>
                  )}
                </div>

                <div>{item.name}</div>
              </div>
            ))}
          </div>
}
          {viewDisplayed === VIEW_STATUS.CALENDAR && (
            <Calendar
              setLoadingData={setLoadingData}
              locationslug={locationslug}
              filterArray={filterArray}
            />
          )}
          {viewDisplayed === VIEW_STATUS.IG_FEED_PREVIEW && (
            <InstagramFeedPreview
              filterArray={filterArray}
              setLoadingData={setLoadingData}
            />
          )}
          {viewDisplayed === VIEW_STATUS.BEST_TIME_TO_POST && (
            <div className="h-100">
              <PlatformHeatmapList />
            </div>
          )}
        </div>{" "}
      </div>
    </div>
  );
};

export default RightScheduling;
